import { Observable } from 'rxjs';

import { PartialRecord } from '../../records/entities/partial-record.class';
import { BatchObject } from './batch-object.entity';
import { SearchRequest } from './batch-options.class';

export interface BatchActionData {
    searchRequest: SearchRequest;
    changes?: PartialRecord[];
    fragments?: readonly PartialRecord[];
    parent?: PartialRecord;
    waitForFinish?: boolean;
    isBulk: boolean;
    profileId?: string;
    exportFileName?: string;
    batchTag?: string;
    headerType?: 'DottedKey' | 'LongTranslation';
}

export enum BatchActions {
    MERGE_MULTIPLE = 'MERGE_MULTIPLE',
    COUPLE_TO_PARENT = 'COUPLE_TO_PARENT',
    REMOVE_FROM_INTELLECTUAL = 'DECOUPLE_FROM_PARENT',
    CSV_EXPORT = 'CSV_EXPORT',
    PUBLISH = 'PUBLISH',
    DELETE = 'DELETE'
}

export type BatchActionToObject = (data: BatchActionData) => Observable<BatchObject>;
